<!-- eslint-disable max-len -->
<template>
  <li :id="participant?.id" class="pagecard">
    <img
      v-if="participant?.attributes?.participant?.data?.attributes?.logo"
      :src="
        useStrapiMediaUrl(
          participant?.attributes?.participant?.data?.attributes?.logo?.data
            .attributes.url,
        )
      "
      class="pagecard__company"
      loading="lazy"
    />
    <div class="pagecard__content">
      <!--
 <img
        :src="
          url +
          participant.attributes.participant.data.attributes.photo.data
            .attributes.url
        "
        class="pagecard__avatar"
      />
-->
      <h3
        class="text-32 text-bold"
        v-html="participant?.attributes?.participant?.data?.attributes?.company"
      />
      <p
        class="text-20"
        v-html="
          participant?.attributes?.participant?.data?.attributes
            .shortDescription
        "
      />
      <img
        :src="
          useStrapiMediaUrl(
            participant?.attributes?.nomination?.data?.attributes?.icon?.data
              ?.attributes?.url,
          )
        "
        class="pagecard__nomination"
        loading="lazy"
      />
      <p
        class="text-20"
        v-html="participant?.attributes?.nomination?.data?.attributes?.name"
      />
      <NuxtLink
        v-if="participant?.attributes?.participant?.data?.attributes?.website"
        :to="participant?.attributes?.participant?.data?.attributes?.website"
        class="pagecard__link"
        target="_blank"
        external
        rel="noopener noreferrer nofollow"
      >
        Ссылка на сайт
      </NuxtLink>
      <NuxtLink 
          v-if="
            participant?.attributes?.participant?.data?.attributes?.ext_link
          "
          :to="
             participant?.attributes?.participant?.data?.attributes?.ext_link
          "
          class="cardmodal__link-ext"
          target="_blank"
          rel="noopener noreferrer nofollow"
          >О компании</NuxtLink>
    </div>

    <div
      v-if="isVotingAllowed && voteEnabled"
      class="pagecard__votes"
      :class="{
        'pagecard__votes--accent': isVotedFor(
          participant?.attributes?.participant?.data?.attributes?.company,
        ),
      }"
    >
      <div class="pagecard__votes-icon">
        <svg
          width="25"
          height="23"
          viewBox="0 0 25 23"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.089 12.2216L12.5106 21.5L2.93227 12.2216C2.30049 11.6203 1.80284 10.8976 1.47067 10.0989C1.1385 9.30027 0.979002 8.443 1.00221 7.58109C1.02543 6.71918 1.23085 5.87131 1.60555 5.09087C1.98025 4.31043 2.51611 3.61432 3.17938 3.04638C3.84265 2.47844 4.61897 2.05098 5.45944 1.7909C6.29992 1.53083 7.18635 1.44378 8.06292 1.53524C8.93948 1.62669 9.78719 1.89467 10.5527 2.32231C11.3181 2.74994 11.9848 3.32796 12.5106 4.01996C13.0388 3.33298 13.7062 2.76001 14.4711 2.33692C15.2361 1.91382 16.0821 1.64971 16.9562 1.56112C17.8303 1.47252 18.7137 1.56134 19.5511 1.82202C20.3885 2.0827 21.1619 2.50963 21.8228 3.07609C22.4837 3.64255 23.018 4.33634 23.3922 5.11405C23.7664 5.89175 23.9724 6.73663 23.9974 7.5958C24.0224 8.45497 23.8658 9.30993 23.5374 10.1072C23.2091 10.9044 22.716 11.6268 22.089 12.2291"
            fill="#76F7FF"
          />
          <path
            d="M22.089 12.2216L12.5106 21.5L2.93227 12.2216C2.30049 11.6203 1.80284 10.8976 1.47067 10.0989C1.1385 9.30027 0.979002 8.443 1.00221 7.58109C1.02543 6.71918 1.23085 5.87131 1.60555 5.09087C1.98025 4.31043 2.51611 3.61432 3.17938 3.04638C3.84265 2.47844 4.61897 2.05098 5.45944 1.7909C6.29992 1.53083 7.18635 1.44378 8.06292 1.53524C8.93948 1.62669 9.78719 1.89467 10.5527 2.32231C11.3181 2.74994 11.9848 3.32796 12.5106 4.01996C13.0388 3.33298 13.7062 2.76001 14.4711 2.33692C15.2361 1.91382 16.0821 1.64971 16.9562 1.56112C17.8303 1.47252 18.7137 1.56134 19.5511 1.82202C20.3885 2.0827 21.1619 2.50963 21.8228 3.07609C22.4837 3.64255 23.018 4.33634 23.3922 5.11405C23.7664 5.89175 23.9724 6.73663 23.9974 7.5958C24.0224 8.45497 23.8658 9.30993 23.5374 10.1072C23.2091 10.9044 22.716 11.6268 22.089 12.2291"
            stroke="#76F7FF"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <span class="pagecard__votes-count">
        {{
          getVotesCount(
            participant?.attributes?.participant?.data?.attributes?.company,
            participant?.attributes?.votes,
          )
        }}
      </span>
    </div>

    <button
      v-if="isVotingAllowed && voteEnabled"
      class="pagecard__more pagecard__more--accent"
      :disabled="!voteAllowed && loggedIn"
      @click="handleVote(participant?.attributes)"
    >
      {{ voteText }}
    </button>
  </li>
</template>
<script setup lang="ts">
import type { Participant } from "~/types/strapiContent"
import { useNominationPageStore } from "~/store/nominationPage"
import type { StrapiResponseData } from "~/types/strapiData"
const store = useNominationPageStore()
const route = useRoute()

const props = defineProps({
  participant: {
    type: Object as () => StrapiResponseData<Participant>,
    required: true,
  },
  voteAllowed: {
    type: Boolean,
    required: false,
    default: false,
  },
  voteText: {
    type: String,
    required: false,
    default: "Голосовать",
  },
})

const emit = defineEmits<{
  (e: "handleOpenPreview"): void
}>()

const handleClick = () => {
  store.dataModal = props.participant
  emit("handleOpenPreview")
}

const { loggedIn, voteEnabled, votedFor } = useAuth()
const isVotedFor = (slug: string) => {
  return !!votedFor().value.find((e) => e.participant === slug)
}
const getVotesCount = (slug: string, num: number = 0) => {
  return isVotedFor(slug) ? Number(num) + 1 : num
}

const handleVote = (participant?: Participant) => {
  if (!loggedIn.value) {
    useState<boolean>("isAuthModalVisible").value = true
    return
  }
  if (!participant) return

  voteConfirmationData().value = participant
}

const allowedVotePages = [
  "/nomination-educational-institutions",
  "/nomination-kids-education",
  "/nomination-language-education",
  "/nomination-dpo",
]

const isVotingAllowed = computed(() => allowedVotePages.includes(route.path))
</script>
<style lang="scss">
.pagecard {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 30px;
  background-color: $primary-black;
  color: $white;
  cursor: pointer;
  border-radius: 10px;
  h3 {
    margin: 0 0 14px 0;
    min-height: 40px;
  }
  span {
    margin: 0 0 14px 0;
    min-height: max-content;
  }
  p {
    margin: 0 0 14px 0;
    min-height: 60px;
  }
  &__content {
    margin: 130px 0 30px 0;
    display: flex;
    flex-direction: column;
  }
  &__company {
    display: block;
    height: 35px;
    max-width: 80%;
    object-fit: contain;
    object-position: left top;
    margin-bottom: auto;

    @include sm {
      height: 35px;
    }
  }
  &__avatar {
    margin: 0 0 14px 0;
    display: block;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: contain;
    object-position: left;
  }
  &__nomination {
    margin: 0 0 14px 0;
    width: 44px;
    height: 34px;
    object-fit: contain;
    object-position: left;
  }
  &__link {
    width: fit-content;
    display: inline-block;
    text-decoration: underline;
    font-size: 12px;
    line-height: 16px;
    transition: ease-in-out 0.335s;
    &:hover {
      opacity: 0.5;
    }
  }
  &__votes {
    --color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
    color: var(--color);
    margin-bottom: 1.825em;

    &--accent {
      --color: #76f7ff;

      .pagecard__votes-icon svg path {
        fill: var(--color);
      }
    }
    & * {
      pointer-events: none;
      user-select: none;
    }
    span {
      margin: 0;
      min-height: unset;
    }
    &-count {
      display: inline-flex;
      transform: translateY(-10%);
    }
    &-icon {
      svg {
        height: 1.45em;
        width: auto;
        overflow: hidden;

        path {
          fill: transparent;
          stroke: var(--color);
        }
      }
    }
  }
  &__more {
    padding: 16px;
    width: 100%;
    border: 1px solid $white;
    border-radius: 60px;
    transition: ease-in-out 0.335s;

    &--accent {
      border-color: transparent;
      background-color: #6a45ff;

      &:disabled {
        cursor: not-allowed;
        pointer-events: none;
        font-size: 0.85em;
        opacity: 0.75;
      }
    }
    &:hover {
      background-color: #5738cf;
      border: 1px solid #5738cf;
    }
    &:not(:first-of-type) {
      margin-top: 1.45em;
    }
  }
}
</style>
